import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';
@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.css']
})
export class DateRangePickerComponent {
  today = new Date();
  
  @Input() cal_img_height:any = "30";
  @Input() filter_btn_padding:any = "6"; 
  @Input() selectedStartDate:any = moment(this.today).add(-7, 'days').format();
  @Input() selectedEndDate:any = this.today;
  @Input() selectedDateRange:string="Past 7 Days";
  @Input() maxDate:Date = new Date();
  @Input() minDate:Date = new Date("2005-01-01");
  @Output() dateRangeChange = new EventEmitter();
  applyClicked:boolean = false; 
  onStartDateChange(event:any){
    this.selectedStartDate = moment(event.value).format();
  }

  onEndDateChange(event:any){
    this.selectedEndDate = moment(event.value).format();
    setTimeout(() => {
      this.setDateRange("");
    }, 100);
  }

  resetDateRange(){
      this.selectedStartDate = moment(this.today).add(-7, 'days').format();
      this.selectedEndDate = this.today;
      this.selectedDateRange = "Past 1 Month";
    }
  
    setDateRange(dateRangeText:string){
      this.selectedDateRange = "Past "+ dateRangeText;
      switch(dateRangeText){
        case "7 Days" : 
        this.selectedStartDate = moment(this.today).add(-7, 'days').format();
        this.selectedEndDate = this.today;      
        break;
        case "1 Month" : 
        this.selectedStartDate = moment(this.today).add(-1, 'months').format();
        this.selectedEndDate = this.today;
        break;
        case "3 Months" : 
        this.selectedStartDate = moment(this.today).add(-3, 'months').format();
        this.selectedEndDate = this.today;
        break;
        case "6 Months" : 
        this.selectedStartDate = moment(this.today).add(-6, 'months').format();
        this.selectedEndDate = this.today;
        break;
        case "9 Months" : 
        this.selectedStartDate = moment(this.today).add(-9, 'months').format();
        this.selectedEndDate = this.today;
        break;
        case "Year" : 
        this.selectedStartDate = moment(this.today).add(-1, 'years').format();
        this.selectedEndDate = this.today;
        this.selectedDateRange = "Last " + dateRangeText;
        break;
        default:
          this.selectedDateRange = "Manual Selection";
      }
      this.dateRangeChange.emit(moment(this.selectedStartDate).format('YYYY-MM-DD') + '::' + moment(this.selectedEndDate).format('YYYY-MM-DD') + '::' + this.selectedDateRange);
    }

    onDateRangeClosed() {
      if(this.applyClicked){
        this.setDateRange(""); 
      }
      this.applyClicked = false;
    }  
}
